import { render, staticRenderFns } from "./informacionProveedor.vue?vue&type=template&id=d8a026c6&scoped=true"
import script from "./informacionProveedor.vue?vue&type=script&lang=js"
export * from "./informacionProveedor.vue?vue&type=script&lang=js"
import style0 from "./informacionProveedor.vue?vue&type=style&index=0&id=d8a026c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a026c6",
  null
  
)

export default component.exports